import { render, staticRenderFns } from "./searchCascader.vue?vue&type=template&id=683c3816&scoped=true"
import script from "./searchCascader.vue?vue&type=script&lang=js"
export * from "./searchCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c3816",
  null
  
)

export default component.exports